import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
  provideRouter,
  RouteReuseStrategy,
  TitleStrategy,
  withComponentInputBinding,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';

import {routes, stripQueryParamsGuard} from './app.routes';
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {authInterceptor} from "./auth.interceptor";
import {versionInterceptor} from "./version.interceptor";
import {providePrimeNG} from "primeng/config";
import {MyPreset} from "./theme";
import {ConfirmationService, MessageService} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {provideServiceWorker} from "@angular/service-worker";
import {environment} from "../../environments/environment";
import {SignupFormService} from "./pages/signup/signup-form.service";
import {TitleAndDescriptionStrategy} from "./title-strategy";
import {ABService} from "./services/a-b.service";
import {provideClientHydration, withNoHttpTransferCache} from '@angular/platform-browser';
import {retryGetInterceptor} from "./core/retry-get.interceptor";
import {isNative} from "./utils";

const hydrationProviders = !isNative
  ? [ provideClientHydration(withNoHttpTransferCache()) ]
  : [];

export class CustomReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot
  ): boolean {
    return future.routeConfig === curr.routeConfig && JSON.stringify(future.params) === JSON.stringify(curr.params);
  }
}

export const sharedProviders = [
  MessageService,
  DialogService,
  ConfirmationService,
  provideAppInitializer(
    () => inject(ABService).initialize(),
  ),
  provideAppInitializer(
    () => inject(SignupFormService).initialize(),
  ),
  provideRouter(
    [
      {
        path: '',
        canActivateChild: [stripQueryParamsGuard],
        children: routes,
      }
    ],
    withRouterConfig({
      onSameUrlNavigation: 'reload',
    }),
    withComponentInputBinding(),
    //withPreloading(PreloadAllModules),
    withViewTransitions({ skipInitialTransition: true })
  ),
  provideServiceWorker('ngsw-worker.js', {
    enabled: environment.supportPWA && !isNative,
    registrationStrategy: 'registerWhenStable:30000'
  }),
  {provide: TitleStrategy, useClass: TitleAndDescriptionStrategy},
  providePrimeNG(
    {
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false,
        }
      }
    }
  ),
  provideAnimations(),
  hydrationProviders,
  {provide: RouteReuseStrategy, useClass: CustomReuseStrategy},
  provideHttpClient(withInterceptors([authInterceptor, retryGetInterceptor, versionInterceptor]), withFetch()),
];

export const sharedAppConfig: ApplicationConfig = {
  providers: sharedProviders,
};
